import { createFileRoute } from '@tanstack/react-router'
import { PlanoB } from '@/features/planb/PlanoB'

/**
 * Plano B num clique.
 *
 * Fica na config e não na tela Hoje porque o link reserva é configuração: ela
 * decide qual é antes do dia ruim, e no dia ruim só confere e aperta.
 */
export const Route = createFileRoute('/_app/app/config/plano-b')({ component: PlanoB })
